<template>
  <div style="width:100%;padding:5px;">
    <el-tabs @tab-click="tabClick">
      <el-tab-pane key="020101" label="执法主体">
        <ul>
          <li
            style="font-size:14px;border-bottom:1px dashed #ccc;padding:2px"
            v-for="(item,index) in list"
            :key="index"
            @click="getDatas(item)"
            :title="item.title"
          >{{item.title.slice(0,50)}}</li>
        </ul>
      </el-tab-pane>
      <el-tab-pane key="020102" label="执法依据">
        <ul>
          <li
            style="font-size:14px;border-bottom:1px dashed #ccc;padding:2px"
            v-for="(item,index) in list"
            :key="index"
            @click="getDatas(item)"
            :title="item.title"
          >{{item.title.slice(0,50)}}</li>
        </ul>
      </el-tab-pane>
      <el-tab-pane key="020103" label="执法程序">
        <ul>
          <li
            style="font-size:14px;border-bottom:1px dashed #ccc;padding:2px"
            v-for="(item,index) in list"
            :key="index"
            @click="getDatas(item)"
            :title="item.title"
          >{{item.title.slice(0,50)}}</li>
        </ul>
      </el-tab-pane>
      <el-tab-pane key="020104" label="当事人救济途径">
        <ul>
          <li
            style="font-size:14px;border-bottom:1px dashed #ccc;padding:2px"
            v-for="(item,index) in list"
            :key="index"
            @click="getDatas(item)"
            :title="item.title"
          >{{item.title.slice(0,50)}}</li>
        </ul>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  data() {
    return {
      html: "",
      jsonData: null,
      pageSize: 15,
      size: 0,
      currentPage: 1,
      list: null
    };
  },
  created() {
    this.onLoadData("020101");
  },

  methods: {
    onLoadData(val) {
      let _this = this;
      let data = {
        filenum: val
      };
      _this.jsonData = null;
      _this.html = "";
      Axios.get("static/json/" + val + ".json").then(function(res) {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].filed = val;
        }
        _this.jsonData = res.data;
        _this.list = _this.jsonData.slice(
          _this.pageSize * _this.currentPage - _this.pageSize,
          _this.pageSize * _this.currentPage
        );
        _this.size = _this.jsonData.length;
      });
    },
    tabClick(a, b) {
      if (a.label == "执法主体") {
        this.onLoadData("020101");
      } else if (a.label == "执法依据") {
        this.onLoadData("020102");
      } else if (a.label == "执法程序") {
        this.onLoadData("020103");
      } else if (a.label == "当事人救济途径") {
        this.onLoadData("020104");
      }
    },
    getDatas(options) {
      this.$emit("updateInfo", options);
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/queryOnline/components/lawEnforcementInfo/index1.vue


// WEBPACK FOOTER //
// src/pages/queryOnline/components/lawEnforcementInfo/index1.vue